module.exports = __webpack_public_path__ + "static/media/food-chain-grapes-desktop.4bc0579e.jpg";